module.exports = __webpack_public_path__ + "22eb3737613eb03c158466ba464aa2a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/admin-template.png
// module id = ./assets/thumbnails/admin-template.png
// module chunks = 2